import {
  SET_VIDEO_CONTROL,
  UPDATE_VIDEO_TIME,
  LOAD_VIDEO_URL,
  CLEAR_VIDEO_URL,
  SET_FULL_ANALYSE_STRING,
  SET_CURRENT_ACTION,
  CLEAR_FULL_ANALYSE_STRING,
  CLEAR_CURRENT_ACTION,
  UPDATE_ACTION_LOG,
  CLEAR_ACTION_LOG,
  CONTROLLER_TOGGLE,
  VIDEO_SEEK_TIME,
  CLEAR_SEEK_FLAG,
  FETCH_MATCH_STRING_SERVER_SUCCESS,
} from "../actions/types";

const INITIAL_STATE = {
  analysedString: {},
  currentAction: "",
  actionLog: [],
  controllerWindowState: false,
  videoControl: false,
  seekToTime: null,
  videoTime: null,
  videoUrl: "",
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOAD_VIDEO_URL:
      return { ...state, videoUrl: action.payload };
    case CLEAR_VIDEO_URL:
      return { ...state, videoUrl: "" };
    case SET_VIDEO_CONTROL:
      return { ...state, videoControl: action.payload };
    case UPDATE_VIDEO_TIME:
      return { ...state, videoTime: action.payload };
    case SET_FULL_ANALYSE_STRING:
      return {
        ...state,
        analysedString: {
          ...state.analysedString,
          [action.payload?.id]: action.payload?.string,
        },
      };
    case SET_CURRENT_ACTION:
      return { ...state, currentAction: action.payload };
    case CLEAR_FULL_ANALYSE_STRING:
      return { ...state, analysedString: {} };
    case CLEAR_CURRENT_ACTION:
      return { ...state, currentAction: "" };
    case UPDATE_ACTION_LOG:
      return { ...state, actionLog: [...state.actionLog, action.payload] };
    case CLEAR_ACTION_LOG:
      return { ...state, actionLog: [] };
    case CONTROLLER_TOGGLE:
      return { ...state, controllerWindowState: action.payload };
    case VIDEO_SEEK_TIME:
      return {
        ...state,
        seekToTime: action.payload,
      };
    case CLEAR_SEEK_FLAG:
      return { ...state, seekToTime: null };
    case FETCH_MATCH_STRING_SERVER_SUCCESS:
      return {
        ...state,
        analysedString: {
          ...state.analysedString,
          [action.payload?.id]: action.payload?.string,
        },
      };
    default:
      return state;
  }
};
